<wui-preview-table>
  <tr class="wui-preview-table__header">
    <th>{{ 'PEPPOL.Preview.Line.Description' | translate }}</th>
    <th class="wui-preview-table__cell--right">
      {{ 'PEPPOL.Preview.Line.Quantity' | translate }}
    </th>
    <th class="wui-preview-table__cell--right">
      {{ 'PEPPOL.Preview.Line.UnitPrice' | translate }}
    </th>
    <th class="wui-preview-table__cell--right">
      {{ 'PEPPOL.Preview.Line.NetTotal' | translate }}
    </th>
    <th class="wui-preview-table__cell--right">
      {{ 'PEPPOL.Preview.Line.VatRate' | translate }}
    </th>
    <th class="wui-preview-table__cell--right">
      {{ 'PEPPOL.Preview.Line.GrossTotal' | translate }}
    </th>
  </tr>

  @for (line of lines(); track line.id) {
    <tr class="wui-preview-table__body">
      @let grossAmount =
        line.totalAmount != null
          ? line.totalAmount * (1 + (line.vatRate ?? 0) / 100)
          : null;
      <td>{{ line.description }}</td>
      <td class="wui-preview-table__cell--right">
        {{ line.quantity | number: '1.2-2' }}
      </td>
      <td class="wui-preview-table__cell--right">
        {{ line.unitPrice | number: '1.2-2' }}
      </td>
      <td class="wui-preview-table__cell--right">
        {{ line.totalAmount | number: '1.2-2' }}
      </td>
      <td class="wui-preview-table__cell--right">{{ line.vatRate }}&nbsp;%</td>
      <td class="wui-preview-table__cell--right">
        {{ grossAmount | number: '1.2-2' }}
      </td>
    </tr>
  }
</wui-preview-table>
